import { ref } from 'vue';
export const  TStrings = ref({
    vittu: 'saatana'
});
